import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import EditStudent from "./EditStudent";

const EditStudentLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Edit Student" />
      <EditStudent />
    </MasterLayout>
  );
};

export default EditStudentLayout;
